import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Cardio.module.css';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBoxObjective, DBTextAreaObjective, DBIntFieldObjective } from '_components';

class PatientCareCenterNoteObjectiveCardio extends React.Component {

    handleClick(selected) {
        if (selected) {
            this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPREHR');
            this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPREBPSYS');
            this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPREBPDIAS');
            this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPOSTHR');
            this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPOSTBPSYS');
            this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPOSTBPDIAS');
        }
    }


    render() {
        return (
            <PatientCareCenterNoteSection id='obj_car' name='Cardiovascular' level={5}>
                   <div className={styles.row}>
                       <div className={styles.flag} />
                       <DBCheckBoxObjective
                           noteId={this.props.noteId}
                           entity='PTOBJECTIVEOBS'
                           entityKeyColumn='OONO'
                           entityKeyValue={this.props.oono}
                           field='OOCARDIONOTTESTED'
                           className={styles.checkbox}
                           label='Not tested at this time'
                           onClick={(selected) => this.handleClick(selected)}
                       />
                   </div>
            {this.props.isNotTestedSelected ?  (
            <div className={styles.row}>
            <div className={styles.row}>
                <span className={styles.txt_flag} />
                 <div className={styles.row}>
                <label className={styles.textarea_label}>Reason BP was not tested:</label>
                </div>
                
                <DBTextAreaObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEOBS'
                    entityKeyColumn='OONO'
                    entityKeyValue={this.props.oono}
                    field='OOCARDIONOTTESTEDREASON'
                    className={styles.textarea}
                />
        
            </div>
            </div>
            ) :
            <div className={styles.row}>
            <div className={styles.row}>
            <span className={styles.pre_flag} />
            <label className={styles.label_req}>Pre-Test:</label>
            
            <label className={styles.field_gap_req}>Heart Rate:</label>
            <DBIntFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEOBS'
                    entityKeyColumn='OONO'
                    entityKeyValue={this.props.oono}
                    field='OOCARDIOPREHR'
                    className={styles.field}
                />
               <span className={styles.row_label_gap}>bpm</span> 

               <label className={styles.section_gap_req}>Blood Pressure:</label>
               <DBIntFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEOBS'
                    entityKeyColumn='OONO'
                    entityKeyValue={this.props.oono}
                    field='OOCARDIOPREBPSYS'
                    className={styles.field}
                />
               <span className={styles.row_label_gap}>/</span> 
               <DBIntFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEOBS'
                    entityKeyColumn='OONO'
                    entityKeyValue={this.props.oono}
                    field='OOCARDIOPREBPDIAS'
                    className={styles.field}
                />
               <span className={styles.row_label_gap}>mmHg</span> 
            </div>
            
            
            <div className={styles.row}>
            <div className={styles.row}>
            <span className={styles.pre_flag} />
            <label className={styles.label}>Post-Test:</label>
            
            <label className={styles.field_gap}>Heart Rate:</label>
            <DBIntFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEOBS'
                    entityKeyColumn='OONO'
                    entityKeyValue={this.props.oono}
                    field='OOCARDIOPOSTHR'
                    className={styles.field}
                />
               <span className={styles.row_label_gap}>bpm</span> 

               <label className={styles.section_gap}>Blood Pressure:</label>
               <DBIntFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEOBS'
                    entityKeyColumn='OONO'
                    entityKeyValue={this.props.oono}
                    field='OOCARDIOPOSTBPSYS'
                    className={styles.field}
                />
               <span className={styles.row_label_gap}>/</span> 
               <DBIntFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEOBS'
                    entityKeyColumn='OONO'
                    entityKeyValue={this.props.oono}
                    field='OOCARDIOPOSTBPDIAS'
                    className={styles.field}
                />
               <span className={styles.row_label_gap}>mmHg</span> 
            </div>
            
                
            </div>
                </div>}
                      
                    </PatientCareCenterNoteSection>
                
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));


    return {
        noteId: noteId,
        oono: oono,
        isNotTestedSelected: (state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIONOTTESTED !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIONOTTESTED !== null)
        || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIONOTTESTED !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIONOTTESTED !== null)
        ? true : false
    };
}

const connectedPatientCareCenterNoteObjectiveCardio = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveCardio);
export { connectedPatientCareCenterNoteObjectiveCardio as PatientCareCenterNoteObjectiveCardio };

